/* unplugin-vue-components disabled */import script from "./PayWithPoints.vue?vue&type=script&setup=true&lang=js"
export * from "./PayWithPoints.vue?vue&type=script&setup=true&lang=js"

import "./PayWithPoints.vue?vue&type=style&index=0&id=efea140c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efea140c"]])

export default __exports__